import { Tooltip } from "@progress/kendo-react-tooltip";
import { useEffect, useState } from "react";
import { RecordingTrackSegment, TrackSegment } from "../../types/player-track";
import { processTrackSegments } from "../../utils/trackInsightUtils";

interface RecordingTrackProps {
  trackLabel: string;
  duration: number;
  segments?: RecordingTrackSegment[];
  error?: string;
  onTrackSpanPlay: (time: number) => void;
  isAIAnalysed?: boolean;
}

export type ShortLabel = {
  label: string;
  cssLabel: string;
};

const getUniqueTrackSegmentLabels = (
  trackSegments: TrackSegment[]
): ShortLabel[] => {
  const result: ShortLabel[] = [];
  const map = new Map<string, ShortLabel>();
  trackSegments.forEach((t) => {
    if (!map.get(t.label)) {
      map.set(t.label, t);
    }
  });

  map.forEach((l) => result.push(l));

  return result;
};

const RecordingTrack: React.FC<RecordingTrackProps> = ({
  trackLabel,
  duration,
  segments,
  error,
  onTrackSpanPlay,
  isAIAnalysed,
}) => {
  const [trackSegments, setTrackSegments] = useState<
    TrackSegment[] | undefined
  >();
  useEffect(() => {
    if (!error && segments) {
      const processedSegments = processTrackSegments(segments, duration);
      setTrackSegments(processedSegments);
    }
  }, [error, segments, duration]);

  const trackSpanClickHandler = (
    e: React.MouseEvent<HTMLSpanElement>,
    start: number
  ) => {
    onTrackSpanPlay(start / 100);
  };
  return (
    <div className="row">
      <div className="col-md-12 d-flex">
        <div className="track m-b-7" style={{ width: "100%" }}>
          <div className="track-single">
            {isAIAnalysed &&
              trackSegments &&
              trackSegments.map((t) => {
                return (
                  <span
                    key={t.id}
                    className={`trackCursor ${t.cssLabel}`}
                    style={{ width: `${t.width}%`, left: `${t.left}%` }}
                    onClick={(e) => trackSpanClickHandler(e, t.left * duration)}
                  ></span>
                );
              })}
          </div>
          <div className="legends d-flex align-items-center">
            <span className="float-left fs-12 font-weight-bold pr-3">
              <div className="d-flex">
                <span>{trackLabel}</span>
              </div>
            </span>
            <ul className="list-unstyled d-flex mb-0">
              {trackSegments &&
                getUniqueTrackSegmentLabels(trackSegments).map((l) => {
                  return (
                    <li key={l.label}>
                      <span className={`legends-bg ${l.cssLabel}`}></span>{" "}
                      {l.label}
                    </li>
                  );
                })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecordingTrack;
